import moment from "moment";
import 'moment-timezone';
import _ from "lodash";
import {CHICAGO_TIMEZONE} from "../Alerts/MissingData/filters";

export const SALES_ANCHOR_START_YEAR = 2022;

export function buildSalesAnchorRows(salesAnchors, {openDate, closedDate} = {}, now = Date.now()) {
    const anchorRows = (salesAnchors || []).map(anchor => ({...anchor, isPlaceholder: false}));
    const anchorYears = new Set(anchorRows.map(({year}) => year));

    const currentYear = moment(now).tz(CHICAGO_TIMEZONE).year();
    const openYear = openDate
        ? moment.tz(openDate, CHICAGO_TIMEZONE).year()
        : SALES_ANCHOR_START_YEAR;
    const closedYear = closedDate
        ? moment.tz(closedDate, CHICAGO_TIMEZONE).year()
        : currentYear;
    const firstYear = Math.max(SALES_ANCHOR_START_YEAR, openYear);
    const lastYear = Math.min(currentYear, closedYear);

    const placeholderRows = (lastYear < firstYear ? [] : _.range(firstYear, lastYear + 1))
        .filter(year => !anchorYears.has(year))
        .map(year => ({year, acvAnchor: null, isPlaceholder: true}));

    return _.orderBy([...anchorRows, ...placeholderRows], ['year'], ['desc']);
}
